import React from 'react';

function Disconnect({ action }) {
    return (
        <div></div>
    )
}

export default Disconnect;
